import firebase from 'firebase/app'
import 'firebase/database'

var config = {
  apiKey: 'AIzaSyCDLFQfCG-u9XNWDFZ7rQigKyjQjdCpXOw',
  serverKey: 'AAAAcvWt63Y:APA91bG35IlRJ_Vzh3gkaBbdZkYwTpcYC7KQ2mpNdXKjECgmdjBkOdp5nBgLob81kPf46bKytxQ67Qo6DP7E-NGg2nDn1K9sI8nwXL22_yE5t6DroavKlbN4JUQdRc0jK-hZSdumrOa-',
  authDomain: 'pxt-dent-notify.firebaseapp.com',
  databaseURL: 'https://pxt-dent-notify.firebaseio.com',
  projectId: 'pxt-dent-notify',
  storageBucket: 'pxt-dent-notify.appspot.com',
  messagingSenderId: '493748087670',
  appId: '1:493748087670:web:b24e24edbf795d2f7d2857'
}

firebase.initializeApp(config)

const database = firebase.database()

export {
  database
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js